/**
 * Anonymous Visitor Tracking & Identity Resolution
 * pvt.js — paste this entire file into Shopify Assets/pvt.js
 */
(function (window, document) {
  "use strict";

  var CONFIG = {
    cookieName: "_pvid",
    cookieMaxAge: 34560000,
    ftCookieName: "_pvft",
    backendEndpoint: null,
    ga4MeasurementId: window.GA4_MEASUREMENT_ID || null,
    debug: false,
  };

  var utils = {
    log: function (msg, data) {
      if (CONFIG.debug && window.console)
        console.log("[PVT] " + msg, data || "");
    },
    generateId: function () {
      var ts = Date.now().toString(36);
      var rnd = Math.random().toString(36).slice(2, 9);
      return "uid_" + ts + "_" + rnd;
    },
    getParam: function (name) {
      var match = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        window.location.search,
      );
      return match ? decodeURIComponent(match[1].replace(/\+/g, " ")) : null;
    },
    setCookie: function (name, value, maxAge) {
      var secure = location.protocol === "https:" ? ";Secure" : "";
      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        ";Max-Age=" +
        maxAge +
        ";Path=/" +
        secure +
        ";SameSite=Lax";
    },
    getCookie: function (name) {
      var match = document.cookie.match(
        new RegExp("(?:^|; )" + name + "=([^;]*)"),
      );
      return match ? decodeURIComponent(match[1]) : null;
    },
    deleteCookie: function (name) {
      document.cookie = name + "=;Max-Age=0;Path=/";
    },
    safeParseJSON: function (str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return null;
      }
    },
    isConsentGiven: function () {
      if (typeof window.userConsent !== "undefined")
        return window.userConsent === true;
      return false;
    },
  };

  var storage = {
    get: function (key) {
      try {
        var v = localStorage.getItem(key);
        if (v) return v;
      } catch (e) {}
      var c = utils.getCookie(key);
      if (c) return c;
      try {
        return sessionStorage.getItem(key);
      } catch (e) {}
      return null;
    },
    set: function (key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
      utils.setCookie(key, value, CONFIG.cookieMaxAge);
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {}
    },
    remove: function (key) {
      try {
        localStorage.removeItem(key);
      } catch (e) {}
      utils.deleteCookie(key);
      try {
        sessionStorage.removeItem(key);
      } catch (e) {}
    },
  };

  var identity = {
    getPseudoId: function () {
      var existing = storage.get(CONFIG.cookieName);
      if (existing) return existing;
      var newId = utils.generateId();
      storage.set(CONFIG.cookieName, newId);
      return newId;
    },
    getOrSetFirstTouch: function (current) {
      var existing = storage.get(CONFIG.ftCookieName);
      if (existing) return utils.safeParseJSON(existing);
      storage.set(CONFIG.ftCookieName, JSON.stringify(current));
      return current;
    },
  };

  var attribution = {
    capture: function () {
      var params = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
        "gclid",
        "fbclid",
        "ttclid",
        "msclkid",
      ];
      var data = {
        landing_page: window.location.href,
        referrer: document.referrer || "",
        timestamp: new Date().toISOString(),
      };
      params.forEach(function (p) {
        var v = utils.getParam(p);
        if (v) data[p] = v;
      });
      if (data.gclid) data.click_source = "google";
      else if (data.fbclid) data.click_source = "facebook";
      else if (data.ttclid) data.click_source = "tiktok";
      else if (data.msclkid) data.click_source = "microsoft";
      else if (data.referrer)
        data.click_source = data.referrer.split("/")[2] || "referral";
      else data.click_source = "direct";
      return data;
    },
  };

  var ga4 = {
    setDimensions: function (pseudoId, userId) {
      if (typeof window.gtag !== "function") return;
      window.gtag("set", "user_properties", { pseudo_id: pseudoId });
      if (userId) {
        window.gtag("config", CONFIG.ga4MeasurementId, {
          user_id: String(userId),
        });
      }
    },
    sendEvent: function (eventName, params) {
      if (typeof window.gtag !== "function") return;
      window.gtag("event", eventName, params);
    },
  };

  var PVT = {
    pseudoId: null,
    firstTouch: null,
    currentTouch: null,
    customerId: null,
    init: function () {
      if (!utils.isConsentGiven()) {
        window.addEventListener("pvt:consent_granted", function () {
          PVT.init();
        });
        return;
      }
      this.pseudoId = identity.getPseudoId();
      this.currentTouch = attribution.capture();
      this.firstTouch = identity.getOrSetFirstTouch(this.currentTouch);
      this.customerId = window.__shopify_customer_id || null;

      ga4.setDimensions(this.pseudoId, this.customerId);
      ga4.sendEvent("pvt_session_start", {
        pseudo_id: this.pseudoId,
        click_source: this.currentTouch.click_source,
        utm_source: this.currentTouch.utm_source || null,
        utm_medium: this.currentTouch.utm_medium || null,
        utm_campaign: this.currentTouch.utm_campaign || null,
        gclid: this.currentTouch.gclid || null,
        fbclid: this.currentTouch.fbclid || null,
        ft_source: this.firstTouch.click_source || null,
        ft_campaign: this.firstTouch.utm_campaign || null,
        ft_timestamp: this.firstTouch.timestamp || null,
        landing_page: this.currentTouch.landing_page,
      });

      window.__pvt = {
        pseudoId: this.pseudoId,
        firstTouch: this.firstTouch,
        currentTouch: this.currentTouch,
        customerId: this.customerId,
      };
      utils.log("Init complete", window.__pvt);
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      PVT.init();
    });
  } else {
    PVT.init();
  }

  window.PVT = PVT;
})(window, document);